import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "@/services/inventory_api";
import type { CatalogEntry, CatalogKind } from "@/services/inventory_types";

/** TYPE-kind raw entries surfaced by the server alongside canonical rows. */
export type CatalogRawEntry = { raw: string; uses: number };

export interface CatalogListResponse {
  items: CatalogEntry[];
  /** Distinct *_raw values the org has typed before. Present on TYPE kinds
   *  (currency / unit / storage-condition / form / standard / claim). */
  raws?: CatalogRawEntry[];
}

export function useInventoryCatalog(kind: CatalogKind, search?: string) {
  return useQuery<CatalogListResponse>({
    queryKey: ["inventory", "catalogs", kind, search ?? null],
    queryFn: () => api.listCatalog(kind, search),
    staleTime: 60_000,
  });
}

export function useInventoryCatalogNormalize(kind: CatalogKind) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (rawValue: string) => api.normalizeCatalog(kind, rawValue),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["inventory", "catalogs", kind] }),
  });
}
